import React from 'react'

const IconHtml = ({ color = 'currentColor', ...rest }) => {
    return (
        <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
            <g clipPath='url(#clip0_3305_5002)'>
                <path
                    d='M12 10.6668L14.6667 8.00016L12 5.3335'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M4.00065 5.3335L1.33398 8.00016L4.00065 10.6668'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M9.66732 2.6665L6.33398 13.3332'
                    stroke={color}
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_3305_5002'>
                    <rect width='16' height='16' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export default IconHtml
